import { PrimaryButton } from '@huggg/react-components';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { getBasePathname } from 'utilities/huggg';
import styles from '../more-details.module.scss';

const ChooseButton = (props) => {
  const { huggg, disabled } = props;

  return (
    <Link
      to={`${getBasePathname(huggg)}/choose`}
      disabled={disabled}
      style={{ width: '320px', marginTop: '8px', textDecoration: 'none' }}
    >
      <PrimaryButton
        label={dictionary.nextButton}
        disabled={disabled}
        className={styles.CTAButton}
      />
    </Link>
  );
};

ChooseButton.propTypes = {
  huggg: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default ChooseButton;
